/**
 * @generated SignedSource<<023409f762d34fb0d53bc95e45b943ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoEditModeBlockData$data = {
  readonly event: {
    readonly __typename: "AuthorizedEvent";
    readonly created: string;
    readonly creators: ReadonlyArray<string>;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly isLive: boolean;
    readonly series: {
      readonly id: string;
      readonly title: string;
    } | null | undefined;
    readonly syncedData: {
      readonly audioOnly: boolean;
      readonly duration: number;
      readonly endTime: string | null | undefined;
      readonly startTime: string | null | undefined;
      readonly thumbnail: string | null | undefined;
    } | null | undefined;
    readonly title: string;
  } | {
    readonly __typename: "NotAllowed";
    readonly __typename: "NotAllowed";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly showLink: boolean;
  readonly showTitle: boolean;
  readonly " $fragmentType": "VideoEditModeBlockData";
};
export type VideoEditModeBlockData$key = {
  readonly " $data"?: VideoEditModeBlockData$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoEditModeBlockData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoEditModeBlockData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Series",
              "kind": "LinkedField",
              "name": "series",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "created",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "creators",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SyncedEventData",
              "kind": "LinkedField",
              "name": "syncedData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumbnail",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "duration",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startTime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endTime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "audioOnly",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "AuthorizedEvent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showLink",
      "storageKey": null
    }
  ],
  "type": "VideoBlock",
  "abstractKey": null
};
})();

(node as any).hash = "9b599fc5bf2aa72693631d2728aeaa7e";

export default node;
